import DescriptionComponent from "components/DescriptionComponent";
import TableAction from "components/TableAction";

import isoToDate from "utils/isoToDate";
export const tableData = ({ onClick, newRoute }) => [
  {
    header: "actions",
    Component: ({ param }) => <TableAction {...{ param, newRoute, onClick }} />,
  },
  {
    header: "name",
    Component: ({ param }) => `${param.name}` || "Unknown",
  },

  {
    header: "description",
    Component: ({ param }) => <DescriptionComponent description={param.description} />,
  },
  {
    header: "listOrderNumber",
    Component: ({ param }) => param.listOrderNumber,
  },
  {
    header: "durationInDays",
    Component: ({ param }) => param.durationInDays,
  },
  {
    header: "actualIdIos",
    Component: ({ param }) => param.actualIdIos,
  },
  {
    header: "actualIdAndroid",
    Component: ({ param }) => param.actualIdAndroid,
  },

  {
    header: "createdAt",
    Component: ({ param }) => isoToDate(param.createdAt),
  },
];
